<template>
  <div class="errors_form">
    <Message severity="error">
      <span class="notice"
        ><b>{{ $t("common.error.notice") }}:</b></span
      >
      <ul>
        <li class="list-group-item" v-for="error in errors" v-bind:key="error">
          <span v-html="error"></span>
        </li>
      </ul>
    </Message>
  </div>
</template>


<script>
export default {
  name: "Errors",
  props: ["errors"],
};
</script>


<style lang="scss" scoped>
</style>